import type { ComponentProps } from "react";
import { Link } from "@tanstack/react-router";
import { tv } from "tailwind-variants";

import { PROGRESS_ENTRY_LINK_LABEL } from "@/domains/progress/utils/progress-entry-points";
import { focusRing, icons } from "@/ui";

/** `min-h-11`: an underlined line of text is about 20px, under the 44px target floor. */
const progressEntryLinkVariants = tv({
  base: `inline-flex min-h-11 w-fit items-center gap-2 rounded-sm font-semibold text-content underline underline-offset-4 transition-colors hover:text-accent ${focusRing}`,
});

export type ProgressEntryLinkProps = Omit<ComponentProps<"a">, "children" | "href">;

export const ProgressEntryLink = ({ className, ...props }: ProgressEntryLinkProps) => {
  return (
    <Link className={progressEntryLinkVariants({ className })} to="/progress" {...props}>
      {PROGRESS_ENTRY_LINK_LABEL}

      <icons.ArrowRight aria-hidden="true" className="size-5" />
    </Link>
  );
};
